"use strict";

IREP.VerificationMain = (function () {
    var defaultSearchValue;
    var resultsList;
    var checkName;

    var init = function (options) {
        $(".optionHeading").click(function () {
            //if the next sectionDetails is visible - close it
            if ($(this).parent().nextAll(".sectionDetails").css("display") == "block") {
                closeSection($(this));
            }
            else  // if it is not visible, close all and show it
            {
                expandSection($(this));
            }
        });

        if ($("#txtFirstName").length && $("#txtLastName").length) {
            checkName = true;
        } else {
            checkName = false;
        }

        var closeSection = function (ctrl) {
            ctrl.parent().nextAll(".sectionDetails").slideUp();
            $(".toggleDiv").addClass("closed");
        }

        var expandSection = function (ctrl) {
            $(".sectionDetails").slideUp();
            $(".toggleDiv").addClass("closed");
            ctrl.parent().nextAll(".sectionDetails").slideDown();
            ctrl.find(".toggleDiv").removeClass("closed");
        }

        $("#consent").removeAttr("checked");

        $("#consent").click(function () {
            if ($("#numAttempts").val() > 0) {
                if ($(".consentDiv").css("display") == "block") {
                    $("#equifaxSubmit").removeAttr("disabled");
                    $(".consentDiv").slideUp();
                    $(".infoDiv").show();
                } else {
                    $("#equifaxSubmit").attr("disabled", "disabled");
                    $(".consentDiv").slideDown();
                    $(".infoDiv").hide();
                }
            } else {
                $("#eqResult").html(options.threechances);
            }
        });

        $(".fakefile").click(function () {
            $("#paystub").click();
        });

        $("#paystub").change(function () {
            $("#filename").html($(this).val().split('\\').pop());
        });

        $("#numAttempts").change(function () {
            if ($(this).val() <= 0) {
                $("#equifaxSubmit").attr("disabled", "disabled");
                $("#eqResult").html($("#eqResult").html() + "<br/>" + options.threechances);
                $(".equifaxVerification").hide();
            }
        });

        $("#storeChainEmails input").change(function () {
            $("#emailDomain").html("@" + $(this).val());
        });

        $(".equifaxVerification").find(".sectionDetails").show();
        $("#equifaxSubmit").click(function () {
            $("#loadingDiv").css({ "display": "block" });

            var params;

            if (checkName) {
                params = { type: 0, firstName: $("#txtFirstName").val(), lastName: $("#txtLastName").val() }
            } else {
                params = { type: 0, firstName: '', lastName: '' };
            }

            IREP.callApi("verification", "POST", params).done(
                function (data) {
                    $("#loadingDiv").css({ "display": "none" });
                    if (data.status) {
                        $("#eqResult").html(options.Congratulations);
                        $("#numAttempts").val(0);
                        $("#consent").hide();
                        $("#equifaxSubmit").hide();
                        $("#CurrentStatus").html("<div class='verified'>" + options.verified + "</div>");
                    } else {
                        $("#eqResult").html(options.Unfortunately);
                        $("#numAttempts").val($("#numAttempts").val() - 1).trigger("change");
                    }
                });
        });

        $("#emailAddressSubmit").click(function () {
            if (($("#emailPrefix").val() != "" && $("#emailPrefix").val() != $("#emailPrefix").attr("defaultVal")) && $('#storeChainEmails input:checked').val() != "") {
                var prefix = $("#emailPrefix").val();
                var domain = $('#storeChainEmails input:checked').val();

                if (prefix.indexOf(" ") >= 0 || prefix.indexOf(",") >= 0 || prefix.indexOf(";") >= 0 || prefix.indexOf("@") >= 0 || prefix.indexOf("&#44;") >= 0 || prefix.indexOf("&#59;") >= 0 || prefix.indexOf("&#64;") >= 0) {
                    $("#CorpEmailError").html("Please remove all illegal characters from your address.");
                }
                else {
                    var params = { type: 2, CorporateEmail: prefix + "@" + domain };
                    IREP.callApi("verification", "POST", params).done(
                        function (data) {
                            if (data.status) {
                                $("#CorpEmailError").html(options.email.toString().replace("[@@domain@@]", prefix + "@" + domain));
                            } else {
                                $("#CorpEmailError").html(options.error);
                            }
                        });
                }
            }
            else {
                $("#CorpEmailError").html(options.select);
            }
        });

        if ($("#showMe").val() == 1) {
            expandSection($("#paystubExapnd"));
        }

        $("#emailPrefix").focus(function () {
            if ($(this).val() == $(this).attr("defaultVal")) {
                $(this).val("");
            }
            $(this).css({ "color": "black" });
        });

        $("#emailPrefix").blur(function () {
            if ($(this).val() == "") {
                $(this).val($(this).attr("defaultVal"));
                $(this).css({ "color": "gray" });
            }

        });
    };


    return {
        init: init
    };
})();